import { createFileRoute } from '@tanstack/react-router'

// Leaf route — Group container is mounted by the parent route.tsx layout.
export const Route = createFileRoute(
  '/_authenticated/project/$projectId/groups/$groupId/$viewType/'
)({
  component: () => null
})
